export default function (el) {
    const text = el.dataset && el.dataset.text ? el.dataset.text : null;

    const handleClick = () => navigator.clipboard.writeText(text);

    if (!text) return;

    el.addEventListener("click", handleClick);
}